import {
  Description as HeadlessDescription,
  type DescriptionProps as HeadlessDescriptionProps,
} from "@headlessui/react";
import { type VariantProps, cva } from "class-variance-authority";

const feedbackMessageVariants = cva(
  "text-base/6 data-[disabled]:opacity-50 sm:text-sm/6",
  {
    variants: {
      defaultVariants: {
        type: "error",
      },
      type: {
        success: "text-success",
        error: "text-error",
      },
    },
  },
);

export type FeedbackMessageProps = VariantProps<
  typeof feedbackMessageVariants
> & { className?: string; disabled?: boolean } & HeadlessDescriptionProps;

export function FeedbackMessage({
  className,
  disabled,
  type,
  ...props
}: FeedbackMessageProps) {
  return (
    <HeadlessDescription
      {...props}
      data-slot="feedback"
      className={feedbackMessageVariants({
        type,
        className,
      })}
    />
  );
}
